import type { ActKc3ActsKc2SelectionItem } from 'gql/graphql';
import { getActKC2StatusColor, getActKC2StatusLabel } from 'pages/Project/Common/types';
import { Badge, Checkbox } from 'uikit';

import { getActNumberAndDate } from './useAddOrEditActsKC3DataFilter';

// eslint-disable-next-line react/display-name
export const NumberAndDateCellRenderer = ({ data }: { data: ActKc3ActsKc2SelectionItem }) => {
    if (!data) {
        return '';
    }

    const { actKC2Status: status } = data;

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Badge
                minified
                size="s"
                label={getActKC2StatusLabel(status)}
                status={getActKC2StatusColor(status)}
                className={getActKC2StatusColor(status) === 'progress' ? 'BadgeColor_progress' : undefined}
            />
            <span style={{ marginLeft: 5 }}>{getActNumberAndDate(data)}</span>
        </div>
    );
};

type TCheckboxCells = {
    onCheck: ({ id, checked }: { id: number; checked: boolean }) => void;
    checkedRows: any;
    isReadonly: boolean | undefined;
};

export const MenuCellRenderer =
    ({ onCheck, checkedRows, isReadonly }: TCheckboxCells) =>
    // eslint-disable-next-line react/display-name
    ({ data }: { data: ActKc3ActsKc2SelectionItem }) => {
        if (!data) {
            return '';
        }

        const { actKC2Id: itemId, actKC2IsCorrectionOfActKC3, actKC2IsIncludedToPrimaryActKC3 } = data;
        const canExcludeAct = actKC2IsCorrectionOfActKC3 || actKC2IsIncludedToPrimaryActKC3;

        const onClick =
            (id: number) =>
            ({ checked }: { checked: boolean }) => {
                onCheck({ id, checked });
            };

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                    checked={checkedRows[itemId]}
                    onChange={onClick(itemId)}
                    disabled={(canExcludeAct && checkedRows[itemId]) || isReadonly}
                />
            </div>
        );
    };
